import { isRelationObject } from './remap-document';

const MONGO_ID_PATTERN = /^[a-f\d]{24}$/i;

const isPopulatedMediaObject = (value: Record<string, unknown>): boolean =>
  typeof value.id === 'string' && typeof value.mimeType === 'string' && ('filename' in value || 'cloudinary' in value);

/**
 * Recursively collects media document IDs from nested module/block data.
 */
export const collectMediaIdsFromValue = (value: unknown, ids: Set<string>): void => {
  if (value === null || value === undefined) return;

  if (typeof value === 'string') {
    if (MONGO_ID_PATTERN.test(value)) {
      ids.add(value);
    }
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item) => collectMediaIdsFromValue(item, ids));
    return;
  }

  if (typeof value !== 'object') return;

  const objectValue = value as Record<string, unknown>;

  if (isPopulatedMediaObject(objectValue)) {
    ids.add(String(objectValue.id));
    return;
  }

  if (isRelationObject(objectValue)) {
    if (!objectValue.relationTo || objectValue.relationTo === 'media') {
      ids.add(String(objectValue.id));
    }
    return;
  }

  for (const nested of Object.values(objectValue)) {
    collectMediaIdsFromValue(nested, ids);
  }
};
